import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import type { NodeViewProps } from '@tiptap/core';
import type { FC } from 'react';

const HtmlComponent: FC<NodeViewProps> = ({ node }) => {
  const htmlContent = node.textContent; // 或者可能需要处理子节点？
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export const HtmlPreviewExtension = Node.create({
  name: 'HtmlPreviewExtension',
  group: 'block',
  priority: 2147483648,
  content: 'inline*',
  addAttributes() {
    return {
      html: {
        default: '',
        parseHTML: (element) => {
          return element.textContent;
        },
      },
    };
  },
  parseHTML() {
    return [
      {
        // 解析条件
        tag: 'webbuilder',
      },
    ];
  },
  renderHTML({ node }) {
    return ['div', { dangerouslyInnerHTML: { __html: node.textContent } }];
  },
  addNodeView() {
    return ReactNodeViewRenderer(HtmlComponent);
  },
});
